import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../../generic-components/Layout';
import BackIcon from '../../../assets/svg/backArrow.svg';
import { APP_LAYOUT_STYLES } from '../../../generic-components/Layout/constants';
import ContentWrapper from '../../../generic-components/ContentWrapper';
import ThreeColumnsContainer from '../../../generic-components/Layout/ThreeColumnsContainer';
import EmergencyBucketMoneyMovement from '../components/EmergencyBucketMoneyMovement';
import { PAGE_HEADERS } from '../constants';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';

const EmergencyBucketAdd = () => {
  const navigate = useNavigate();
  const { SAVINGS, EMERGENCY } = PAGE_HEADERS.ADD;

  const { t } = useTranslation();

  return (
    <AppLayout
      assetPath={BackIcon}
      title={validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? t(SAVINGS) : t(EMERGENCY)}
      titleStyle='font-metricMedium text-bw08 text-xl ml-[1rem]'
      backButtonStyle='flex items-center justify-center w-[2rem] h-[2rem]'
      backDestination={0}
      layoutStyle={`${APP_LAYOUT_STYLES.LAYOUT} gap-0`}
      navBarStyle={`${APP_LAYOUT_STYLES.NAVBAR.HEADER_STYLE} mt-[1rem]`}
      handleNavigate={() => { navigate('/emergency-bucket-dashboard/:main'); }}
    >
      <ContentWrapper>
        <ThreeColumnsContainer
          firstColumnClassname='w-[22.5rem] max-h-[27.5rem]'
          firstColumnChildren={[<EmergencyBucketMoneyMovement pullFromBucket={false} />]}
        />
      </ContentWrapper>
    </AppLayout>
  );
};

export default EmergencyBucketAdd;
